<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g opacity=".75"><path d="M7.552.103c.281-.137.61-.137.89 0l5.083 2.463c.264.129.462.362.549.643L15.947 9.2a1.1 1.1 0 0 1-.1.89l-3.221 5.4c-.186.316-.524.51-.89.513H4.264a1.039 1.039 0 0 1-.89-.512L.152 10.095a1.1 1.1 0 0 1-.1-.891L1.92 3.209c.086-.281.285-.514.549-.643L7.552.103Z" opacity=".6" fill="currentColor"/><path d="M5.812 15.76a.264.264 0 0 0 .26.24h5.66c.366-.002.704-.197.89-.512l3.22-5.4a1.1 1.1 0 0 0 .1-.891l-1.048-3.37a.262.262 0 0 0-.25-.185h-9.3a.532.532 0 0 0-.518.594l.986 9.524Z" fill="currentColor"/></g><path d="M11.61 8.077a.515.515 0 0 0-.6.2l-5.06 7.555a.108.108 0 0 0 .087.168h5.694c.366-.002.704-.197.89-.512l3.268-5.476a.326.326 0 0 0-.165-.473L11.61 8.077Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering133',
});
</script>
